module.exports = __webpack_public_path__ + "img/cloudy-icon.b887acd0.svg";